export const force = <T>(input: T | null | undefined) => {
  if (input === null) {
    throw new Error("a null valiue was passed to the force function");
  }

  if (input === undefined) {
    throw new Error("an undefined value was passed on to the force function");
  }

  return input;
};
